import React from "react";

const DiskHeader = () => {
  return (
    <div className="filesystem__disk" data-test="container">
      <h5 className="filesystem__disk__text">Hard Disk Drives</h5>
      <div className="filesystem__disk__divider" />
    </div>
  );
};

export default DiskHeader;
